export const phoneTypes = [
  { value: 'work', label: 'Work' },
  { value: 'home', label: 'Home' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'other', label: 'Other' },
]

export const placeOfEmployments = [
  { value: 'Academia/Education', label: 'Academia/Education' },
  { value: 'Acute Care Hospital', label: 'Acute Care Hospital' },
  { value: 'Long Term Acute Care Hospital', label: 'Long Term Acute Care Hospital' },
  { value: 'Administration', label: 'Administration' },
  { value: 'Ambulatory', label: 'Ambulatory' },
  { value: 'Insurance Case Management', label: 'Insurance Case Management' },
  { value: 'Private Practice', label: 'Private Practice' },
  { value: 'Home Health Care/Hospice', label: 'Home Health Care/Hospice' },
  { value: 'Independent Consultant', label: 'Independent Consultant' },
  { value: 'Industry/Sales', label: 'Industry/Sales' },
  { value: 'Long Term Care/Skilled Nursing/Nursing Rehab', label: 'Long Term Care/Skilled Nursing/Nursing Rehab' },
  { value: 'Outpatient Wound Center', label: 'Outpatient Wound Center' },
  { value: 'other', label: 'Other' },
]

export const managementLevels = [
  { value: 'Not a manager', label: 'Not a manager' },
  { value: 'Manager or supervisor', label: 'Manager or supervisor' },
  { value: 'Executive/Director', label: 'Executive/Director' },
  { value: 'Top Senior/Strategic Leader', label: 'Top Senior/Strategic Leader' },
]

export const WCCertifications = [
  'CWCA',
  'CWOCN',
  'CWSP',
  'WCC',
  'CWCMS',
  'CWON',
  'DWC',
  'WTA',
  'CWCN',
  'CWS',
  'OMS',
  'Other',
]

export const licenseTypes = [
  'APN',
  'LPN',
  'LVN',
  'RN',
  'NP',
  'OT',
  'OTA',
  'PT',
  'PTA',
  'PA',
  'MD',
  'DO',
  'DPM',
  'RD',
  'RDN',
  'DTR',
  'NDTR',
  'None',
  'Other',
]

export const howDidYouHearAboutUs = [
  { value: 'I was referred by an existing alumni who is WCC, DWC, OMS or CWCMS', label: 'I was referred by an existing alumni who is WCC, DWC, OMS or CWCMS' },
  { value: 'I received an email from WCEI', label: 'I received an email from WCEI' },
  { value: 'I received a postcard or brochure in the mail from WCEI', label: 'I received a postcard or brochure in the mail from WCEI' },
  { value: 'I heard about it while attending a webinar, seminar or conference', label: 'I heard about it while attending a webinar, seminar or conference' },
  { value: 'My employer or colleague (non-alumni) recommended it', label: 'My employer or colleague (non-alumni) recommended it' },
  { value: 'I was searching for information on the internet (Google, Yahoo, Bing)', label: 'I was searching for information on the internet (Google, Yahoo, Bing)' },
  { value: 'I saw it on social media (Facebook, Twitter, LinkedIn, Pinterest)', label: 'I saw it on social media (Facebook, Twitter, LinkedIn, Pinterest)' },
  { value: 'I saw it on the NAWCO website', label: 'I saw it on the NAWCO website' },
  { value: 'I received a phone call or voicemail from WCEI', label: 'I received a phone call or voicemail from WCEI' },
  { value: 'I saw an advertisement in a print journal, magazine, or newspaper', label: 'I saw an advertisement in a print journal, magazine, or newspaper' },
  { value: 'I saw an advertisment on an online journal, magazine, or newspaper', label: 'I saw an advertisment on an online journal, magazine, or newspaper' },
]
